module.exports = __webpack_public_path__ + "static/media/Jacob Kowalski 2.05ae5993.jpg";